module.exports = __webpack_public_path__ + "img/vue1-doublure_blanc.089ce7ba.png";